export const PLANNING_ALERTS_ENABLED = process.env.NEXT_PUBLIC_CITYSCOPE_ALERTS_ENABLED === '1';
